<template>
  <div class="mt-5">
    <v-container class="text-center">
      <v-divider class="mb-1"></v-divider>
      <v-divider class="mb-5"></v-divider>

      <v-img
        class="ems-image mb-8 mx-auto"
        src="@/assets/ems_images/werek_construction.png"
        style="width: 150px; height: auto"
      ></v-img>

      <v-responsive class="mx-auto title font-weight-light mb-8" max-width="720"
        >For over 40 years, Werek Construction has established itself as a
        trusted leader in the construction industry, renowned for our unwavering
        commitment to safety, exceptional construction expertise, and
        proficiency in handling hazardous materials. Our dedication to
        excellence ensures that each project we undertake meets the highest
        standards of quality and precision..
      </v-responsive>

      <v-responsive class="mx-auto title font-weight-light mb-8" max-width="720"
        >At Werek Construction, safety is paramount. We are backed by a robust
        $10 million liability insurance policy, affirming our comprehensive
        coverage across all operations. As a bonded entity, we offer our clients
        the assurance of our financial strength and accountability.
      </v-responsive>

      <v-divider class="mb-1 mt-10"></v-divider>
      <v-divider class="mb-10"></v-divider>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "services",
  components: {},
  data() {
    return {};
  },
  mounted() {},
};
</script>

<style>
</style>